/*
 * Created on Sat Jun 19 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

import React, { useEffect, useState, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from "../assets/images/icons/pink-logo-48.png";
import { Tabs } from './here';
import TopNav from 'components/shared/top-nav';
import { useWindowDimensions } from '../utils/helpers';
import useAuth from 'hooks/auth.hook'

export default function Terms() {
    const { fetching, session } = useAuth()
    const { hash } = useLocation()
    document.body.style.background = '#cdcdcd';
    const visibleRef = useRef();
    const { windowWidth, isMobile } = useWindowDimensions();
    const [top, setTop] = useState(session ? '25px' : isMobile ? '65px' : '45px');
    
    const getTop = (top) => setTop(top);

    useEffect(() => {
        if (!fetching && session) {
            const anchor = document.getElementById(hash.substring(1))
            if (anchor) {
                window.scrollTo({
                    top: anchor.offsetTop - 90
                })
            }
        }
        return () => {

        }
    }, [fetching, session])

    return (
        <>
            <ScrollToTopButton passTop={getTop} loggedIn={!fetching && session} windowWidth={windowWidth} />
            <div id="policyMain">

                <StickyHeader top={top} tabIndex={0} loggedIn={!fetching && session} />

                <div className="policy-page">

                    <div className={"policy-header " + (!fetching && session ? "pt-0" : "")}>
                        <h1>terms of use</h1>
                        <div className="date">Updated: 29 October 2018</div>
                    </div>

                    <div className="policy-intro">
                        Welcome to <b>itch</b>—your fashion media driven by you.
                    </div>

                    <div className="policy-format">

                        <div ref={visibleRef}>
                            <p>The products and services on the <b>itch</b> website (<a href="http://www.itch.me" className="pink-text">www.itch.me</a>)
                                (“<b>itch</b>”) are provided by us, Groundcrew Pte. Ltd. (201536895Z) (“us” or “we”). These terms of
                                use ("Terms") represent legally binding terms and conditions which govern your use of and access to
                                <b> itch</b>, and the products and services we offer through <b>itch</b> ("Services").
                                By clicking your consent (e.g. “Confirm,” “Sign-in,” or “Sign-up,”) or by using our Services,
                                you agree to these Terms, so please read these Terms carefully and contact us at <a href="mailto:legal@itch.me" className="pink-text">legal@itch.me</a> if you have any questions.
                                We have tried our best to keep the legalese to the minimum.
                            </p>
                        </div>

                        <h1>1. about itch</h1>
                        <p><b>itch</b> is a fashion-only, social media and editorial platform that allows users who comply with these Terms to
                            showcase themselves, get inspirations from across the world, find collaborations, market directly, amass
                            contacts, write fashion-related <b>articles</b> and collectively determine our <b>zine</b> features (main editorial) with
                            their social actions and vice versa, the equal opportunity of getting featured by the <b>itch</b> community.</p>
                        <p>The <b>itch articles</b> and other facilities enable you to post fashion-only content for other users to view and access.
                            Unless we expressly say so, we do not monitor, interfere with or edit the content that you and other users post in <b>itch</b>.
                            “Content” includes data, text, information, usernames, graphics, images, photographs, profiles, audio, video, items, and
                            links posted by you or other users on <b>itch</b>.</p>
                        <p>We are not involved in any communications between the users of <b>itch</b>, whether they are <b>fa</b> (fashion artist), <b>fc</b> (fashion company) or <b>fl</b>
                            (fashion lover), nor are we responsible for any of their actions on <b>itch</b>, including the content they post on their <b>profiles</b> and <b>billboard</b>,
                            their <b>gallery</b>, their <b>articles</b> or elsewhere in <b>itch</b>. Therefore, <b>itch</b> has no control over the quality, safety, originality, morality or legality
                            of any of the content you or other users post or upload on <b>itch</b>.</p>

                        <h1>2. binding agreement</h1>
                        <p>By accessing or using our Services, you agree to be bound by:</p>

                        <ul>
                            <li>
                                <h2>Binding Agreement</h2>
                                <p>These Terms and any other rules or policies we may create from time to time (“Policies”), and
                                    which represent a binding legal agreement between you (or where you represent a business entity,
                                    that business entity) and us;</p>
                            </li>
                            <li>
                                <h2>Third Party Terms</h2>
                                <p>Any terms and conditions of third-party service providers and platforms whose website, software
                                    or services are accessed through your use of or access to our Services; and</p>
                            </li>
                            <li>
                                <h2>Privacy Policy</h2>
                                <p>Our <Link to="/here/privacy" className="pink-text">Privacy Policy</Link>, found
                                    <Link to="/here/privacy" className="pink-text"> here</Link>, and which is incorporated in these Terms
                                    by reference.</p>
                            </li>
                        </ul>

                        <h1>3. using our services</h1>
                        <ul>
                            <li>
                                <h2>Age</h2>
                                <p>Only individuals who are 18 years and older and who can form legally binding contracts may use
                                    our Services.</p>
                                <p>If you are below 18 years old, you may use our Services only under the supervision of a parent or
                                    guardian who is at least 18 years old. We will regard the parent or guardian as the person
                                    entering into a legally binding contract with us, and will look to him or her for full
                                    responsibility for all activities of the minor on <b>itch</b> and in respect of the Services.
                                </p>
                            </li>
                            <li>
                                <h2>Information</h2>
                                <p className="mb-0">All information you submit when creating and accessing your <b>itch</b> account
                                    must be:</p>
                                <ol className="mb-4">
                                    <li className="font-weight-normal">
                                        <p>accurate, complete, current, and true, and you must ensure they stay that way,</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>information about you only, and not of someone else. You must use your own name when you
                                            sign up for an account with us.</p>
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <h2>International Users</h2>
                                <p>While access to and use of the Services are maintained and offered by us from our facilities in
                                    Singapore, they may be accessible to you even if you live outside Singapore. However, we do not
                                    guarantee that your access to or use of <b>itch</b>, the rest of our Services or any of the
                                    user-generated content on <b>itch</b>, is in compliance with the laws of your country. If you
                                    reside outside Singapore, it is solely your responsibility to make sure your access to and use
                                    of the Services or any user-generated content is legal in the country in which you live.</p>
                            </li>

                            <li>
                                <h2>Use by and for Individuals Only</h2>
                                <p>Our Services are to be used only by and for individuals. Companies, businesses and any
                                    organisations which are owners, licensees or representatives of brands or fashion labels are not
                                    permitted to access and use our Services or to register for an account. You must not seek to
                                    transfer your account or any alleged rights in it to any other individual or organisation,
                                    whether for commercial profit or any other reason, without our express prior written consent.
                                </p>
                            </li>

                            <li>
                                <h2>Representatives</h2>
                                <p>You may register an account (i) on your own behalf as a Fashion Artist, Fashion Company, or
                                    Fashion Lover, or (ii) through a personal assistant, administrative assistant or other
                                    representative who acts on your behalf (a “representative”), and only if you additionally meet
                                    the eligibility criteria for the Fashion Artist, Fashion Company, or Fashion Lover account as
                                    stated in these Terms.</p>

                                <p>Where a user is the representative of a Fashion Artist, Fashion Company, or Fashion Lover, we will
                                    treat the Fashion Artist, Fashion Company, and Fashion Lover as the person who has entered into a
                                    legally binding contract with us under these Terms, and will look to him or her to be fully responsible
                                    for all the activities of the representative.</p>
                            </li>

                            <li>
                                <h2>Impersonation</h2>
                                <p>As <b>itch</b> is also designed to help promote fashion professionals in the fashion industry, we
                                    feel very strongly about any impersonation of someone else or the taking of credit for someone
                                    else’s creations or work. We therefore require that you use your [own and real name] in your
                                    <b> profile</b>.</p>
                            </li>

                            <li>
                                <h2>Safety</h2>
                                <p>We cannot guarantee the true identity of a user or that a user is who he/she claims he/she is,
                                    even while we encourage you to communicate directly with other users on <b>itch</b> as
                                    <b> itch</b> is an online community for all fashion creatives as well as enthusiasts to connect
                                    with one another. We therefore urge users to use caution and good judgment in their
                                    communications with other users, and you acknowledge that you are solely responsible for your
                                    own safety and the consequences of any commercial and personal dealings you enter into with
                                    another user on <b>itch</b>. You may wish to consider using a third-party service that provides
                                    user verification.</p>
                            </li>

                            <li>
                                <a id="misuse"/>
                                <h2>Misuse</h2>
                                <p className="mb-0">You must not misuse <b>itch</b> or any of our other Services by or for doing
                                    anything criminal, dishonest, malicious, or unlawful, or any of the following:</p>
                                <ol className="mb-4">
                                    <li className="font-weight-normal">
                                        <p>committing or encouraging a criminal offence;</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>using our Services to do anything or communicate with other users in a manner which is
                                            bullying, intimidating, harmful, threatening, insulting, abusive, tortious, defamatory,
                                            libellous, pornographic, lewd, profane, obscene, hateful or otherwise objectionable;</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>transmitting or distributing into <b>itch</b> or our Services or other users' viruses,
                                            Trojan horses, worms, logic bombs or any material that is intended to damage or limit
                                            the functionality of our Services or that of other users’ computers such as denial of
                                            service attacks;</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>hacking into any aspect of our Services or corrupting any data;</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>harassing, stalking or causing alarm or distress to another user;</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>sending any unsolicited material in bulk to other users, where such material is for the
                                            purpose of offering to supply or advertising or promoting goods or services or a
                                            supplier of goods or services, offering, advertising or promoting land or an interest in
                                            land or an investment or business opportunity or a provider of land or an investment or
                                            business opportunity;</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>attempting to affect the performance or functionality of any computer facilities of or
                                            accessed throughout <b>itch</b>;</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>attempting to collect or download any information about or regarding us, our Services,
                                            our content or other users of our Services or other users’ content through automated
                                            means such as bots, spiders, scripts, robots or scrapers or otherwise;</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>using (or assisting or enabling a person to use) deception or dishonesty to obtain
                                            property belonging to another person;
                                        </p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>engaging in any unlawful multi-level marketing, such as a pyramid scheme; and</p>
                                    </li>
                                    <li className="font-weight-normal">
                                        <p>taking any action that imposes, or may impose, an unreasonable or disproportionately
                                            large load on our infrastructure.</p>
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <h2>Access to the Services</h2>
                                <p>We cannot, and do not, guarantee continuous, uninterrupted access to <b>itch</b> or the Services,
                                    as the operation of <b>itch</b> may be interfered with due to numerous factors outside of our
                                    control.</p>
                            </li>

                            <li>
                                <h2>Termination by You</h2>
                                <p>You may stop using any of our Services and deactivate your account at any time.</p>
                            </li>

                            <li>
                                <h2>Hyperlinks</h2>
                                <p>For your convenience, we may include hyperlinks to other websites or content on the internet that
                                    are owned or operated by third parties. These linked websites or content are not under our
                                    control and we are not liable for any errors, omissions, delays, defamation, libel, slander,
                                    falsehood, obscenity, pornography, profanity, inaccuracy or any other objectionable material
                                    contained in the contents, or the consequences of accessing, any linked website, and are not
                                    endorsed or verified by us and your access to or use of such linked websites or content is
                                    entirely at your own risk.</p>

                            </li>
                            <li>
                                <h2>Help Us</h2>
                                <p>Please help us make <b>itch</b> a place where we, you and your friends would like it to be, by
                                    reporting any misuse of <b>itch</b> or objectionable conduct to us by clicking on the flag
                                    button or contacting us at <a href="mailto:legal@itch.me" className="pink-text">legal@itch.me</a>.</p>
                            </li>
                        </ul>

                        <h1>4. itch accounts</h1>

                        <ul>
                            <li>
                                <h2>Types of Accounts</h2>
                                <p>To use our Services, you must first register an account with us. There are three categories of
                                    accounts you can register with us: 1. <b>FA</b> ("Fashion Artist"), 2. <b>FC</b> ("Fashion
                                    Company"), and 3. <b>FL</b> ("Fashion Lover").</p>

                                <ol>
                                    <li>
                                        <p><b>FA</b> account:</p>
                                        <p>A Fashion Artist account may only be registered and used by individuals who are:</p>
                                        <ul className="list-unstyled">
                                            <li>- <b>fashion designers</b></li>
                                            <li>- <b>fashion models</b></li>
                                            <li>- <b>fashion photographers</b></li>
                                            <li>- <b>fashion videographers</b></li>
                                            <li>- <b>fashion hair stylists</b></li>
                                            <li>- <b>fashion makeup artists</b> </li>
                                            <li>- <b>fashion stylists</b></li>
                                            <li>- <b>fashion nail artists</b></li>
                                            <li>- <b>fashion creative directors</b></li>
                                            <li>- <b>fashion retouchers</b></li>
                                        </ul>
                                        <p className="pt-4">
                                            To uphold the identities of legitimate fashion artists that are: <b>fashion
                                                designers</b>, <b>fashion models</b>, <b>fashion photographers</b>, <b>fashion videographers</b>
                                            , <b>fashion hair stylists</b>, <b>fashion makeup artists</b>, <b>fashion stylists</b>,
                                            <b>fashion nail artists</b>, <b>fashion creative directors</b>, <b>fashion retouchers</b>, we have the sole and
                                            absolute discretion as to whether or not you meet our eligibility criteria for
                                            registering for a Fashion Artist account, and our decision is final.
                                        </p>
                                    </li>

                                    <li className="pt-4">
                                        <p><b>FC</b> account:</p>
                                        <p>A Fashion Company account may only be registered and used by fashion companies who strictly owns a Fashion Brand,
                                            Service or an Agency. To honour the art of fashion and uphold the identities of legitimate fashion companies, we
                                            have the sole and absolute discretion as to whether or not you meet our eligibility criteria for registering for
                                            a Fashion Company account, and our decision is final.</p>
                                    </li>

                                    <li className="pt-4">
                                        <p><b>FL</b> account:</p>
                                        <p>A Fashion Lover account may be registered and used by any individual who registers with us for a Fashion Lover account,
                                            and is meant for people such as fashion bloggers, merchandisers or any fashion enthusiasts who loves fashion and would
                                            like to connect directly with Fashion Artists, Fashion Companies and other Fashion Lovers on <b>itch</b>.</p>
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <h2>Inactive or Unconfirmed Accounts</h2>
                                <p>When you apply to register an account with us, we require you to confirm the application in the
                                    manner stipulated by us. We also encourage you to frequently log into <b>itch</b> and use our
                                    Services. Where you fail to confirm your account or are an inactive user, we have the right to
                                    cancel your account.</p>
                            </li>

                            <li>
                                <h2>Multiple Accounts</h2>
                                <p>If you are a Fashion Artist with multiple expertise (e.g., you are a fashion stylist, makeup
                                    artist and hairstylist), you may select up to 3 different account types under <b>fa</b> (fashion artist)
                                    for your <b>itch</b> profile. You must not register for more than one account under each of the categories
                                    of accounts. For example, you cannot register for two Fashion Company accounts under the same company
                                    name. You can register for multiple accounts from each of the three categories of accounts on <b>itch</b>,
                                    as long as you meet the eligibility criteria for each of those accounts. For example, you may register
                                    for an account as a <b>fa</b> (fashion Artist) and also an account as a <b>fc</b> (fashion company).</p>
                            </li>

                            <li>
                                <h2>Cancellation or Rejection of Registrations: </h2>
                                <p className="mb-0">We have the right to refuse to offer access to or use of any Service or
                                    <b> itch</b> to you, or to approve your application to register an account, and to suspend or
                                    terminate your user account even if it was previously registered, and to change the eligibility
                                    criteria for registration of the different types of accounts at any time, for any reason and
                                    without notice to you, and also for any the following reasons:</p>
                                <ol>
                                    <li className="font-weight-normal">you register a fake user account or impersonate someone else;</li>
                                    <li className="font-weight-normal">you register more than one account of any of the types of accounts available on <b>itch </b>
                                        (for e.g. registering for two Fashion Company accounts under the same company name);</li>
                                    <li className="font-weight-normal">you upload or post content on your profile which you did not create (or if you are a
                                        Representative, which the Fashion Artist, Fashion Company, Fashion Lover you represent, did not create);</li>
                                    <li className="font-weight-normal">in registering an account, you provide information which is not accurate, complete, current,
                                        and true;</li>
                                    <li className="font-weight-normal">you are not of the minimum age required by the law of your country for use and access to our
                                        Services and to <b>itch</b>; </li>
                                    <li className="font-weight-normal">you do not meet the eligibility criteria required for the type of account which you have
                                        applied to register with us; and</li>
                                    <li className="font-weight-normal">we are of the opinion that you have breached any of the terms and conditions in these Terms.
                                    </li>
                                </ol>
                            </li>
                        </ul>

                        <h1>5. content</h1>

                        <ul>
                            <li>
                                <h2>Your Content</h2>
                                <p>At <b>itch</b>, we are a strong believer that you retain your rights to the content you submit,
                                    post or display on <b>itch</b> or through the Services. While we do not claim any ownership rights
                                    in any content (including audio recordings, data, photos, videos, artwork, texts, links, and
                                    other materials) that you post on <b>itch</b>, we do require certain licences to your content to
                                    operate and enable the Services.</p>
                            </li>

                            <li>
                                <h2>Our Use of Your Content</h2>
                                <p className="mb-0">Unless otherwise agreed in writing, you grant <b>itch</b> a non-exclusive, worldwide, fully paid,
                                    perpetual, irrevocable, royalty-free, and sub-licensable licence to use, reproduce, modify, adapt, publish,
                                    translate, create derivative works from, distribute, publicly perform and display your content and any name,
                                    username or likeness provided in connection with your content in all media formats and distribution methods now
                                    known or later developed on the Services. Please understand that <b>itch</b> requires this license because you own your
                                    content hence <b>itch</b> can’t display it across its various surfaces (i.e., mobile, web) without your permission. As
                                    fellow creatives, we respect your intellectual property as much as we do ours. Therefore, this type of license is
                                    needed to distribute your content across our services. Our use of the content you publish or upload on <b>itch</b> or
                                    through any Services is for any purpose including:
                                </p>
                                <ol>
                                    <li className="font-weight-normal">marketing, advertising and promoting you, our Services to you or other users; </li>
                                    <li className="font-weight-normal">featuring you on our <b>Zine</b> (editorial) and promoting you and your content;</li>
                                    <li className="font-weight-normal">developing and operating <b>itch</b>, and providing you and other users with our Services.
                                    </li>
                                </ol>
                            </li>

                            <li>
                                <a id="protecting-rights"/>
                                <h2>Protecting Rights</h2>
                                <p>We respect other people’s intellectual property, contractual, confidentiality, privacy and other
                                    rights, and expect you do the same. You must therefore not post any content or take any action
                                    on <b>itch</b> or through the Services that infringes someone else's intellectual property,
                                    contractual, confidentiality, privacy and other rights or is otherwise illegal. You must
                                    therefore only post or upload content that you own or for which you have all relevant rights and
                                    permissions for.</p>

                                <p>You agree that we are not responsible or liable for any content, and you therefore acknowledge
                                    that you use our Service at your own risk.</p>

                            </li>
                            <li>
                                <h2>Reporting Infringements</h2>
                                <p>We are not responsible for the content posted or uploaded by you or any other users of
                                    <b> itch</b> and our Services.</p>

                                <p className="mb-0">Nonetheless, where you come across content posted by other users which you own
                                    or have exclusive rights for, please report this to us immediately by clicking on the flag
                                    button or contacting us at <a href="mailto:legal@itch.me" className="pink-text">legal@itch.me</a>, and provide us with
                                    the following:</p>
                                <ol>
                                    <li className="font-weight-normal">a description of the copyrighted work or trade mark which you believe has been infringed
                                        (“Infringing Material”);</li>
                                    <li className="font-weight-normal">the location (URL) where the infringing material resides on <b>itch</b> or a description of
                                        the location;</li>
                                    <li className="font-weight-normal">your telephone number and physical address so that we can better get in touch with you; and
                                    </li>
                                    <li className="font-weight-normal">such other information as we reasonably require from you,</li>
                                </ol>
                                <p>and we will investigate and consider actions which include removing such content and suspending
                                    or terminating the account or use of our Services for users who repeatedly infringe other users’
                                    or persons’ rights. If we remove your content for infringing someone’s rights, and you believe
                                    we removed it by mistake, we will give you the opportunity to appeal.</p>

                            </li>
                            <li>
                                <h2>Content Retention</h2>
                                <p>On the termination or deactivation of your account, or if you remove any of your content from
                                    <b> itch</b>, we have the right to retain your content for a commercially reasonable period of
                                    time for audit, archival or backup, purposes. Kindly refer to our <Link to="/here/privacy" className="pink-text">Privacy Policy</Link> found <Link to="/here/privacy" className="pink-text">here</Link> for more information.</p>
                            </li>
                        </ul>

                        <h1>6. our intellectual property rights</h1>

                        <ul>
                            <li>
                                <h2>Ownership of itch Materials</h2>
                                <p><b>itch</b> and the other Services and any <b>itch</b> Marks, text, write-ups, software, content,
                                    features, designs, artwork, and compilations (including the "look", "feel", "appearance",
                                    "graphic functions", colour combinations, sounds, and layouts of <b>itch</b> (“itch Materials”)
                                    that we make available to you as part of the Services, are protected by intellectual property
                                    rights which are owned or licensed to us. “itch Marks” means “<b>itch</b>”, the <b>itch </b>
                                    logo, the domain name <a href="http://www.itch.me" className="pink-text">www.itch.me</a>, and any other trade mark,
                                    logo, trade dress, domain names or evidence of ownership belonging to Groundcrew Pte Ltd.</p>

                                <p>You acknowledge that using our Services and accessing <b>itch</b>, does not mean you own any of
                                    the <b>itch</b> Materials or any of the intellectual property rights in them, and you must not
                                    reproduce, modify, display, sell, or distribute the <b>itch</b> Materials or use any of the
                                    <b> itch</b> Materials in any other way for public or commercial purpose, without our express
                                    written permission.</p>
                            </li>

                            <li>
                                <h2>Prohibited Actions</h2>
                                <p>You must not contest or deny the validity of our right, title or interest to or any licence of
                                    the <b>itch</b> Trade Marks, and you must not encourage or assist others directly or indirectly
                                    to do so. You must not use the <b>itch</b> Trade Marks in any manner that would diminish or harm
                                    their value or reputation and you must not use or register any domain name, trade mark, business
                                    entity or trading name that contains any words or marks that are identical to or similar to any
                                    of the <b>itch</b> Trade Marks.</p>
                            </li>

                            <li>
                                <h2>Software</h2>
                                <p>If we make certain software (including standalone software products, mobile applications or
                                    browser plugins) available to you as part of the Service, such software may be on the terms of a
                                    separate licence or use agreement which you must agree to for the use of the software. If no
                                    such separate license agreement is made available, then we hereby grant you a personal,
                                    non-exclusive, non-transferrable, and non-sub-licensable license to use such software only for
                                    the purpose of letting you use the Services in accordance with these Terms. You must not copy,
                                    modify, distribute, sell, or license any part of the Services or the software, nor can you
                                    reverse engineer or decompile the software or attempt to extract source code from it. The
                                    software may or may not automatically download and install updates from us, which are designed
                                    to improve and enhance the Services and may be by way of bug fixes, new software modules, and
                                    new versions. You agree to receive such updates (and consent to us delivering these updates to
                                    you without your knowledge) as part of your use of the Services.</p>
                            </li>

                            <li>
                                <h2>Unsolicited Ideas</h2>
                                <p>While we welcome feedback from users regarding the Services, please do not send us any
                                    unsolicited ideas, suggestions, or proposals as to how to improve or further develop the
                                    Services or <b>itch</b> other than those we specifically request. This is to avoid future
                                    misunderstandings where new functionalities and features developed by us might be similar or
                                    even identical to your idea.</p>

                                <p>If you nonetheless send us an unsolicited suggestion, idea, or proposal, such submission will not
                                    be considered your confidential or proprietary information, and we are entitled to unrestricted
                                    use of any part of the submission for any purpose, commercial or otherwise, without compensation
                                    to you.</p>
                            </li>
                        </ul>

                        <h1>7. limitation of liability</h1>

                        <ul>
                            <li>
                                <h2>As Is</h2>
                                <p>The Services are provided to you “as is”, and “as available”, and without any warranty of any
                                    kind, whether express or implied (including any implied warranty of merchantability or
                                    satisfactory quality, fitness for a particular purpose, compliance with any description, or any
                                    implied warranty arising from course of performance, course of dealing, usage of trade or
                                    otherwise, all of which are expressly disclaimed).</p>

                            </li>
                            <li>
                                <h2>Non-liability</h2>
                                <p>We, and our parent company, subsidiaries, and affiliates, and their officers, directors, agents,
                                    contractors, and employees are not and will not be liable for any damages, whether direct,
                                    indirect, general, special, compensatory, consequential, and/or incidental, arising out of or
                                    relating to your conduct or of anyone else in connection with the use of <b>itch</b>, our
                                    Services, or these Terms, including lost profits, bodily injury, emotional distress, or any
                                    special, incidental or consequential damages.</p>
                            </li>

                            <li>
                                <h2>Sole Remedy</h2>
                                <p>You acknowledge and agree that your only remedy and right with respect to any dissatisfaction or
                                    issue with our Services is to request for termination of your account or discontinuation of any
                                    use of the Services.</p>
                            </li>
                        </ul>

                        <h1>8. indemnity</h1>
                        <p>You agree to reimburse and absolve us and our parent company, subsidiaries, affiliates, officers,
                            directors, agents, contractors, and employees, from any responsibility for or from any claim or demand,
                            including legal fees, made by any third-party due to or arising out of your breach of these Terms or the
                            documents or laws they incorporate by reference, or your violation of any law or the rights of a third
                            party.</p>

                        <h1>9. breach</h1>

                        <ul>
                            <li>
                                <h2>Full Discretion</h2>
                                <p>We have full discretion to determine whether a breach of these Terms has occurred during your
                                    access to and use of <b>itch</b> and any other part of the Services.</p>

                            </li>
                            <li>
                                <h2>Breach</h2>
                                <p className="mb-0">Where we determine that such a breach has occurred, that you have engaged in
                                    any unlawful, fraudulent or unethical conduct, or that you have misused any of the Services
                                    (whether as mentioned under clause 3 above or otherwise) or where we determine that complaints
                                    by users against you are substantiated and of serious misconduct, without affecting any other
                                    remedies we have under these Terms or at law, we have the right to take such action as we deem
                                    appropriate at any time, with or without prior notice to you, including all or any of the
                                    following:</p>
                                <ol>
                                    <li className="font-weight-normal">issue a warning to you;</li>
                                    <li className="font-weight-normal">temporarily or permanently refuse to provide any or all of the Services to you;</li>
                                    <li className="font-weight-normal">suspend or terminate your account with <b>itch</b>;</li>
                                    <li className="font-weight-normal">temporarily or indefinitely suspend your account privileges;</li>
                                    <li className="font-weight-normal">take technical and legal actions to prevent you from accessing <b>itch</b> and to
                                        re-register for an account; </li>
                                    <li className="font-weight-normal">warn other users of your actions</li>
                                    <li className="font-weight-normal">institute legal proceedings against you;</li>
                                    <li className="font-weight-normal">disclose such information related to your breach to law enforcement authorities as we may
                                        feel is necessary; and</li>
                                    <li className="font-weight-normal">take a combination of any of the actions in this clause 9.</li>
                                </ol>

                                <p>If we believe that you are impersonating someone or stealing someone else’s
                                    credit, we may transfer your account to the person you are impersonating, apart from taking any
                                    of the other actions above.</p>
                            </li>

                            <li>
                                <h2>Survival</h2>
                                <p>Clauses 5 (Content), 6 (Our Intellectual Property Rights), 7 (Limitation of Liability), 8
                                    (Indemnity), 9 (Breach), and 10 (General) shall survive any termination or expiration of the
                                    agreement between you and us.</p>
                            </li>
                        </ul>

                        <h1>10. general</h1>

                        <ul>
                            <li>
                                <h2>Amendments</h2>
                                <p>We have the right to from time to time amend these Terms, the Privacy Policy and the Policies, by
                                    posting the modified or revised version on <b>itch</b>. The revised Terms, Privacy Policy and
                                    revised or new Policies takes effect immediately once we post it on <b>itch</b>, and you agree
                                    to be bound by all such modifications or revisions or new Policies. If a revision, in our sole
                                    discretion, is material we will notify you at the email address you provided to us when
                                    registering for your account. If you do not agree to the new Terms, Privacy Policy or the
                                    Policies, please immediately stop using our Services.</p>
                            </li>

                            <li>
                                <h2>Cumulative Remedies</h2>
                                <p>Our rights and remedies under these Terms of Use do not affect and are in addition to any other
                                    rights or remedies we may have in law or in equity.</p>
                            </li>

                            <li>
                                <h2>Transferability</h2>
                                <p>These Terms, and any rights and licences granted under it, may not be transferred or assigned by
                                    you, but may be assigned by us without restriction.</p>
                            </li>

                            <li>
                                <h2>Entire Agreement</h2>
                                <p>These Terms (including the Privacy Policy and the Policies), form the entire agreement between us
                                    in relation to your access to and use of the Services.</p>
                            </li>

                            <li>
                                <h2>Reservation of Rights</h2>
                                <p>We reserve all rights not expressly granted to you under these Terms.</p>
                            </li>

                            <li>
                                <h2>Severability</h2>
                                <p>If any provision of these Terms is held unenforceable, it will be removed or modified as little
                                    as possible, and the rest of these Terms will remain in full force and effect.</p>
                            </li>

                            <li>
                                <h2>No Waiver</h2>
                                <p>No waiver of any provision of these Terms will be deemed a further or continuing waiver of such
                                    provisions or other provisions or any of our rights.</p>
                            </li>

                            <li>
                                <h2>Governing Law and Jurisdiction</h2>
                                <p>These Terms are to be interpreted by the laws of Singapore, and you agree to submit to the
                                    non-exclusive jurisdiction of the courts of Singapore for all disputes arising out of them.</p>
                            </li>
                        </ul>
                    </div>

                    <div className="policy-footer">
                        Thank you for taking your time to read through our Terms of Use. Should you have any questions regarding our
                        Terms, feel free to email us at: <a href="mailto:legal@itch.me" className="pink-text">legal@itch.me</a>.
                    </div>

                </div>
            </div>
        </>
    );
}

export function ScrollToTopButton({ passTop, loggedIn, windowWidth }) {
    const [isVisible, setIsVisible] = useState(false);
    const [top, setTop] = useState({
        initial: 0,
        final: 0,
        scroll: 0
    });

    const scrollToTop = () =>
        window.scrollTo({
            top: top.initial,
            left: 0,
            behavior: "smooth"
        });

    useEffect(() => {
        if (loggedIn) {
            if (windowWidth > 926) {
                setTop({
                    initial: 25,
                    final: -20,
                    scroll: 65
                });
            }
            else {
                setTop({
                    initial: 0,
                    final: -38,
                    scroll: 45
                });
            }
        }
        else {
            setTop({
                initial: windowWidth > 926 ? 65 : 45,
                final: windowWidth > 926 ? 65 : 45,
                scroll: 0
            });
        }
        // eslint-disable-next-line
    }, [windowWidth])

    useEffect(() => {
        const onScroll = () => {
            window.scrollY > 600 ? setIsVisible(true) : setIsVisible(false);
            window.scrollY > 0 ? passTop(top.final) : passTop(top.initial);
        };
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
        // eslint-disable-next-line
    }, [top])

    return (
        <div className="scroll-to-top-container" style={{
            display: isVisible ? null : 'none'
        }}>
            <div className="scroll-to-top-button" onClick={scrollToTop} style={{
                opacity: isVisible ? 1 : 0,
                top: top.scroll
            }}>
                <div className="scroll-to-top-icon sprites sprites-image-2"></div>
            </div>
        </div>
    )
}

export function StickyHeader({ top, tabIndex, text, loggedIn, takeOver = false }) {
    return (
        <div className="sticky-header" style={{
            top: top,
            zIndex: takeOver ? 110: 2
        }}>

            <div className="icon">
                {/* only display logo when logged in */}
                {!loggedIn ?
                    <Link to="/"><img src={logo} alt="logo" /></Link>
                    : null}
            </div>

            <div className="header">
                <div className="term">{text ? text : 'privacy & terms'}</div>
                <div className="line mb-0"></div>
            </div>

            {tabIndex >= 0 ? <Tabs activeTab={tabIndex} /> : null}
        </div>
    )
}

export function UseIntersection(element, rootMargin) {
    const [isVisible, setState] = useState(true);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                setState(entry.isIntersecting);
            }, { rootMargin }
        );
        const ref = element.current;
        element && observer.observe(ref);

        return () => observer.unobserve(ref);
    });

    return isVisible;
};